import { render, staticRenderFns } from "./EstimatePreliminaryGroupItem.vue?vue&type=template&id=01274f4f&"
import script from "./EstimatePreliminaryGroupItem.vue?vue&type=script&lang=js&"
export * from "./EstimatePreliminaryGroupItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports